export default "__VITE_ASSET__Cb14vf1$__"